
import { apiFetch } from './client';
import type { Task } from '../types/contracts';

export const tasksApi = {
  list:       ()                              => apiFetch<Task[]>('/api/tasks'),
  complete:   (id: string)                   => apiFetch<void>(`/api/tasks/${id}/complete`,   { method: 'POST' }),
  reschedule: (id: string, when: string)     => apiFetch<void>(`/api/tasks/${id}/reschedule`,
    { method: 'POST', body: JSON.stringify({ when }) }),
  cancel:     (id: string)                   => apiFetch<void>(`/api/tasks/${id}/cancel`,     { method: 'POST' }),
  create:     (d: { input: string; when: string; repeatEveryMin?: number; agentId?: string }) =>
    apiFetch<Task>('/api/tasks', { method: 'POST', body: JSON.stringify(d) }),
  update:     (id: string, d: { input?: string; when?: string; repeatEveryMin?: number }) =>
    apiFetch<Task>(`/api/tasks/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  remove:     (id: string)                   => apiFetch<{ deleted: boolean; id: string }>(`/api/tasks/${id}`, { method: 'DELETE' }),
};
